import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";
import {Response} from "@QUERIES/types";

interface CouponByUser {
	multiUseYn: string; // Y 중복쿠폰 / N 단일쿠폰
	couponNm: string; // 쿠폰명
	issueYn: string; // Y 발급가능 / N 발급불가
	couponNo: string; // 쿠폰번호
	discDiviCd: string; // M 정액 / R 정률
	discRate: number; // 할인율
	discAmt: number; // 할인금액
	goodsPriceCd: string; // 상품가격코드
	goodsPriceFr: number; // 상품가 최소 금액
	goodsPriceTo: number; // 상품가 최대 금액
	downYn: string; // 다운로드 여부
	regDt: string; // 등록일
	issueDt: string; // 발급일
	validityFrDt: string; // 유효시작일
	validityToDt: string; // 유효종료일
	evAdtPrice: number; // 성인 총상품가
	evChdPrice: number; // 소아 총상품가
	evInfPrice: number; // 유아 총상품가
	issueCnt: number; // 발급수량
	issueCntTot: number; // 발급총수량
	couponDivi: string; // 쿠폰구분 (BA 일반 / GR 등급 / PA 제휴)
	custGradeCd: string; // 고객등급
	couponIssueSeq: string; // 쿠폰발급순번
	discAmtNo?: number; // 할인금액순번
	applied?: string; // 적용 여부
	remainCnt: number; // 선착순 잔여 수량
	fcfsYn: string; // Y 선착순 쿠폰 / N 일반 쿠폰
}

/** ```
 * 쿠폰 리스트 조회 by user
 *   `/pkg/coupon/by-event/${evCd}/${webCustNo}`
 * parameter
 *   `evCd` 예약자 일련번호
 *   `webCustNo` 회원 일련번호
 * ```*/
const key = `useCouponByUser`;
const getPath = (evCd: string, webCustNo: string): string | null => {
	if (!evCd || !webCustNo) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/coupon/by-event/${evCd}/${webCustNo}`;
};

const useCouponByUser = (
	evCd: string,
	webCustNo: string,
	options?: Partial<UseQueryOptions<Response<CouponByUser[]>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath(evCd, webCustNo)],
		queryFn: () => useConfigureAxios({url: getPath(evCd, webCustNo)}).then(r => r.data),
		staleTime: 0,
		gcTime: 0,
		...options,
	});

export default useCouponByUser;
export {getPath, key};
export type {CouponByUser};
